import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {SegmentedControl} from '@primer/react'

import {CustomPropertySingleSelectPanel, type CustomPropertySingleSelectPanelProps} from './CustomPropertySelectPanel'

interface CustomPropertyBooleanSelectProps extends CustomPropertySingleSelectPanelProps {
  propertyValue: string
}

export function CustomPropertyBooleanSelect(inputProps: CustomPropertyBooleanSelectProps) {
  const booleanToggleEnabled = useFeatureFlag('boolean_property_value_toggle')

  const {propertyDefinition, propertyValue, onChange} = inputProps
  const {defaultValue} = propertyDefinition

  const buttonValues = ['true', 'false', '']

  return booleanToggleEnabled && !defaultValue ? (
    <SegmentedControl
      aria-label="True/False property value selections"
      onChange={(index: number) => onChange(buttonValues[index] || '')}
    >
      <SegmentedControl.Button selected={propertyValue === 'true'} type="button">
        True
      </SegmentedControl.Button>
      <SegmentedControl.Button selected={propertyValue === 'false'} type="button">
        False
      </SegmentedControl.Button>
      <SegmentedControl.Button selected={propertyValue === ''} type="button">
        Not set
      </SegmentedControl.Button>
    </SegmentedControl>
  ) : (
    <CustomPropertySingleSelectPanel
      {...inputProps}
      propertyDefinition={{...propertyDefinition, allowedValues: ['true', 'false']}}
    />
  )
}

try{ CustomPropertyBooleanSelect.displayName ||= 'CustomPropertyBooleanSelect' } catch {}